import {useEffect, useState} from "react";

export default function PlantenCalculator({selectedVariant, setProductQuantity, openAction = '', setOpenAction}) {
    const [inputM2, setInputM2] = useState(0);
    const [inputPerM2, setInputPerM2] = useState(
        selectedVariant?.product?.greenProperties?.plantenperm2 ? selectedVariant?.product?.greenProperties?.plantenperm2 : 0
    );
    const [isActive, setIsActive] = useState(false);

    const calculateQuantity = () => {
        setProductQuantity(inputPerM2 * inputM2);
    };

    useEffect(() => {
        setIsActive((openAction === 'plantenCalculator'));
    }, [openAction]);

    return (
        <>
            <div
                className={`bg-white flex flex-col border-2 border-olaf-green-500 rounded-tl-lg rounded-br-lg px-2 py-1 cursor-pointer col-start-1 row-start-1 relative 
                ${isActive && 'border-0 rounded-br-none activeProductAction'}`
                }>
                <div
                    className="flex flex-col justify-center items-center"
                    onClick={() =>
                        isActive
                            ? setOpenAction(false)
                            : setOpenAction('plantenCalculator')
                    }
                >
                    <img
                        src="/assets/icon/calculator.svg"
                        alt="Calculator icon"
                        width={'41'}
                        height={'41'}
                        className={'my-2'}
                    />
                    <div>
                        <p className={'font-semibold text-olaf-green-500 text-base'}>Plantencalculator</p>
                    </div>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 14 14"
                        xmlns="http://www.w3.org/2000/svg"
                        className={`text-olaf-green-500 my-2 ${openAction === 'plantenCalculator' && 'opacity-0'}`}
                    >
                        <rect
                            y="6.73291"
                            width="2.72043"
                            height="9.53696"
                            rx="0.680107"
                            transform="rotate(-45 0 6.73291)"
                            fill="currentColor"
                        />
                        <rect
                            x="7.93115"
                            y="12.2666"
                            width="2.72043"
                            height="7.82658"
                            rx="0.680107"
                            transform="rotate(-135 7.93115 12.2666)"
                            fill="currentColor"
                        />
                    </svg>
                </div>
            </div>
            {isActive && (
                <div className="col-span-2 col-row-2 bg-white p-4">
                    <div className={'border border-olaf-green-500 p-4'}>
                        <p className="text-xs lg:text-base">
                            De plantencalculator adviseert je hoevel planten
                            je nodig hebt per m2 (bijvoorbeeld plantvak of
                            border).
                        </p>
                        <hr className="border-olaf-green-500 my-4"/>
                        <div className="flex items-center">
                            <div className="w-1/3 shrink-0">
                                <p className="text-sm text-olaf-green-500">
                                    <strong>Aantal per m2</strong>
                                </p>
                            </div>
                            <div className="ml-4 w-2/3 flex items-center">
                                <div className="w-full">
                                    <input
                                        type="number"
                                        placeholder="per m2"
                                        defaultValue={inputPerM2}
                                        onChange={(e) =>
                                            setInputPerM2(e.target.value)
                                        }
                                        className="bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none border-white"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center">
                            <div className="w-1/3 shrink-0">
                                <p className="text-sm text-olaf-green-500">
                                    <strong>Aantal m2</strong>
                                </p>
                            </div>
                            <div className="ml-4 w-2/3 flex items-center">
                                <div className="w-full">
                                    <input
                                        type="number"
                                        placeholder="m2"
                                        onChange={(e) =>
                                            setInputM2(e.target.value)
                                        }
                                        className="bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none border-white"
                                    />
                                </div>
                            </div>
                        </div>
                        <span
                            className="cursor-pointer h-[40px] flex items-center justify-center rounded-tl-[10px] rounded-br-[10px] text-sm font-bold border-2 bg-olaf-green-500 text-white border-olaf-green-500 ml-auto w-fit px-8 mt-2"
                            onClick={() => calculateQuantity()}
                        >
                                Plantadvies overnemen
                              </span>
                    </div>
                </div>
            )}
        </>
    );
}